<template>
    <h3 class="loading-layout">{{text}}</h3>
</template>

<script>
    export default {
        name: 'LoadingText',
        props: {
            text: {
                type: String,
                default: 'Fetching this data...'
            }
        }
    };
</script>

<style scoped>

    @media (prefers-reduced-motion: no-preference) {

        @keyframes Blinking {
            from {
                opacity: .3;
            }
            to {
                opacity: 1;
            }
        }

        .loading-layout {
            animation: Blinking infinite alternate 2s;
        }
    }
</style>
